module.exports = __webpack_public_path__ + "static/img/4areaA_16.f5984d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/4areaA_16.png
// module id = 1029
// module chunks = 1